module.exports = __webpack_public_path__ + "static/media/slzhitui-bg1.d9c8c276.png";